import { Text } from 'Shared/forms/Inputs';
import { LabelOnRightWrap } from 'Shared/forms/Wrap';
import { StyleFieldsRow } from 'Shared/backend/styles/StyleFieldsRow';


export function Height()
{
	return (
		<StyleFieldsRow>
			<HeightFields />
		</StyleFieldsRow>
	);
}


/* The height on its own, for a caller that names the location itself - see ruleProperties(). A css
   length string ('50%', '60px'); empty contributes nothing. */
export function HeightFields()
{
	return (
		<LabelOnRightWrap label='' narrow={true}>
			<Text field='height' placeholder='e.g. 50%' />
		</LabelOnRightWrap>
	);
}
